import { Subject, Observable, of } from "rxjs";
import { Injectable } from '@angular/core';
import { ConfigurationService } from "./configuration.service";
import { HttpClient } from "@angular/common/http";
import * as moment from 'moment';
import { Items } from "../models/items";
import { catchError } from "rxjs/operators";
import { NotifMessageService } from "./notifmessage.service";
import { Transaction } from "../models/transaction";
import { UtilsService } from "./utils.service";


@Injectable({ providedIn: 'root' })
export class TransactionService {

    constructor(
        private http: HttpClient,
        private configService: ConfigurationService,
        private notifService: NotifMessageService,
        private utilsService: UtilsService
    ) { }

    transactionSubject = new Subject<any[]>();
    transactionSubjectPager = new Subject<Items<any>>();

    emitTransactionPager(transaction) {
        this.transactionSubjectPager.next(transaction);
    }

    emitTransactionsByTransaction(criteria) {
        this.transactionSubject.next(criteria);
    }

    getTransactionById(id): Observable<Transaction> {
        return this.http.get<any>(`${this.configService.config.urlAPI.urlTransaction}/${id}`).pipe(catchError(err => {
            console.log("error", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_TRANSACTION_API', err);
            let emptyItem = new Transaction();
            return of(emptyItem);
        }));
    }

    findByCriteria(criteria, pager): Observable<Items<Transaction>> {
        this.utilsService.updateCriteriaWindowFromTo(criteria);

          let params = {};
          Object.assign(params, pager, criteria);
        return this.http.get<any>(this.configService.config.urlAPI.urlTransaction, {params: params}).pipe(catchError(err => {
            console.log("error findBYCriteria", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_TRANSACTION_API', err);
            let emptyList = new Items<Transaction>();
            emptyList.content = [];
            return of(emptyList);
        }));
    }


    downloadFile(data, filename = 'data') {
      data = data.map(elt => {
          elt.merchantExtRef = elt.merchantRef;
          return elt;
      } )
      let csvData = this.convertToCSV(data);
      let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
      let dwldLink = document.createElement("a");
      let url = URL.createObjectURL(blob);
      let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
      if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
          dwldLink.setAttribute("target", "_blank");
      }
      dwldLink.setAttribute("href", url);
      dwldLink.setAttribute("download", filename + ".csv");
      dwldLink.style.visibility = "hidden";
      document.body.appendChild(dwldLink);
      dwldLink.click();
      document.body.removeChild(dwldLink);
  }

  tx = new Object();

  convertToCSV(objArray) {
      this.tx = {
          id: "",
          paymentMeanId: "",
          maskedPan: "",
          walletId: "",
          pumpNumber: 0,
          posId: 0,
          supplierId: 0,
          merchantId: 0,
          supplierRef: "",
          merchantRef: "",
          amount: 0,
          currency: "",
          quantity: 0,
          unitOfMeasure: "",
          transactionStateHistory: [],
          transactionState: "",
          paymentTransactionId: "",
          productType: "",
          productCode : "",
          description : "",
          vatAmount: 0,
          taxPercentage: 0,
          unitPrice: 0,
          completionDate: "",
          lastModifiedDate: "",
          createdDate: "",
          createdBy: "",
          lastModifiedBy: "",
          invoiceId: "",
      };
      let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
      const separator = ',';
      const keys = Object.keys(this.tx);
      const csvData =
          keys.join(separator) +
          '\n' +
          array.map(row => {
              return keys.map(k => {
                  let cell = row[k] === null || row[k] === undefined ? '' : row[k];
                  if (cell instanceof Array && cell.length > 0) {
                      let values = cell.map(o => Object.values(o).join(',')).join('\t');
                      cell = values;
                  }
                  cell = cell instanceof Date
                      ? cell.toLocaleString()
                      : cell.toString().replace(/"/g, '""');

                  if (cell.search(/("|,|\n)/g) >= 0) {
                      cell = `"${cell}"`;
                  }
                  return cell;
              }).join(separator);
          }).join('\n');
      return csvData;
  }
}
